module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "メーカ（詳細）"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _vm._e(), _vm._v(" "), (_vm.read_only == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e()])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteMasterMakerModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4412aba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0041_master_maker_detail.vue
// module id = 1072
// module chunks = 0